import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Layout({
  children,
  ProjectShowcase,
  OnChangeSearchInput,
  isShowProjectDropDown,
  allProjects,
  initialSearchValue,
}) {
  return (
    <div className="min-h-[100svh] flex flex-col ">
      <Header
        position={"sticky"}
        bg={"bg-white"}
        ProjectShowcase={ProjectShowcase}
        OnChangeSearchInput={OnChangeSearchInput}
        isShowProjectDropDown={isShowProjectDropDown}
        allProjects={allProjects}
        initialSearchValue={initialSearchValue}
      />
      <main className="bg-white mb-4 grow">{children}</main>
      <Footer />
    </div>
  );
}
